<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { lang } from "../i18n";
  import STREETS from "../../data/streets.json";
  import Icon from "../ui/Icon.svelte";
  const dispatch = createEventDispatcher();

  export let placeholderText;

  let query = "";
  let resultIndex = 0;
  let results = [];
  let inputRef;
  $: {
    if (query.trim().length < 2) {
      results = [];
    } else {
      const regex = new RegExp(query, "i");
      results = STREETS.filter((street) => regex.test(street.nl) || regex.test(street.fr));
      results = results.slice(0, 10);
      if (results.length > 0) {
        resultIndex = 0;
      }
    }
  }

  const handleChange = (e) => {
    query = e.target.value;
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 38) {
      // Key up
      e.preventDefault();
      let newResultIndex = resultIndex - 1;
      if (newResultIndex < 0) {
        newResultIndex = results.length - 1;
      }
      resultIndex = newResultIndex;
    } else if (e.keyCode === 40) {
      // Key down
      e.preventDefault();
      let newResultIndex = resultIndex + 1;
      if (newResultIndex >= results.length) {
        newResultIndex = 0;
      }
      resultIndex = newResultIndex;
    } else if (e.keyCode === 13) {
      // Enter
      e.preventDefault();
      const result = results[resultIndex];
      dispatch("select", { result });
      closeResults();
    } else if (e.keyCode === 27) {
      closeResults();
    }
  };

  const closeResults = () => {
    results = [];
    resultIndex = -1;
    query = "";
  };

  const handleSelect = (result) => {
    dispatch("select", { result });
  };

  onMount(() => {
    inputRef.focus();
  });
</script>

<div class="search-body">
  <input
    class="search-input"
    type="text"
    placeholder={placeholderText}
    value={query}
    on:input={handleChange}
    on:keydown={handleKeyDown}
    bind:this={inputRef}
  />
  <div class="search-icon"><Icon name="search" width={20} /></div>
  {#if results.length > 0}
    <div class="cna-search-results">
      {#each results as result, index}
        <div
          class="cna-search-item {index === resultIndex ? ' cna-search-item--active' : ''}"
          key={index}
          on:click={handleSelect(result)}
        >
          {result[$lang] || result["nl"]}
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .search-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    position: relative;
  }

  .search-input {
    width: 100%;
    height: 2rem;
    border: none;
    border: 1px solid #e4e4e7;
    border-radius: 3px;
    font: inherit;
    font-size: 1.2rem;
    padding: 5px 10px;
    color: #222;
    background-color: transparent;
    outline: none;
  }

  .search-icon {
    position: absolute;
    top: 6px;
    right: 7px;
  }

  .cna-search-results {
    position: absolute;
    top: 40px;
    left: -22px;
    padding: 10px;
    background-color: white;
    width: 400px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .cna-search-item {
    background-color: white;
    padding: 0.5rem 1rem;
    cursor: pointer;
    border-radius: 3px;
  }

  .cna-search-item--active {
    background-color: #f0f0f0;
  }
</style>
